export const HTTP_MEETINGS_FETCHING = "HTTP_MEETINGS_FETCHING";
export const HTTP_MEETINGS_SUCCESS = "HTTP_MEETINGS_SUCCESS";
export const HTTP_MEETINGS_FAILED = "HTTP_MEETINGS_FAILED";

export const HTTP_MEETING_FETCHING = "HTTP_MEETING_FETCHING";
export const HTTP_MEETING_SUCCESS = "HTTP_MEETING_SUCCESS";
export const HTTP_MEETING_FAILED = "HTTP_MEETING_FAILED";

export const HTTP_EVENT_FETCHING = "HTTP_EVENT_FETCHING";
export const HTTP_EVENT_SUCCESS = "HTTP_EVENT_SUCCESS";
export const HTTP_EVENT_FAILED = "HTTP_EVENT_FAILED";

export const HTTP_DOCUMENTS_FETCHING = "HTTP_DOCUMENTS_FETCHING";
export const HTTP_DOCUMENTS_SUCCESS = "HTTP_DOCUMENTS_SUCCESS";
export const HTTP_DOCUMENTS_FAILED = "HTTP_DOCUMENTS_FAILED";

export const HTTP_ATTENDEES_FETCHING = "HTTP_ATTENDEES_FETCHING";
export const HTTP_ATTENDEES_SUCCESS = "HTTP_ATTENDEES_SUCCESS";
export const HTTP_ATTENDEES_FAILED = "HTTP_ATTENDEES_FAILED";

export const HTTP_ATTACHMENTS_FETCHING = "HTTP_ATTACHMENTS_FETCHING";
export const HTTP_ATTACHMENTS_SUCCESS = "HTTP_ATTACHMENTS_SUCCESS";
export const HTTP_ATTACHMENTS_FAILED = "HTTP_ATTACHMENTS_FAILED";

export const HTTP_TEMPLATES_FETCHING = "HTTP_TEMPLATES_FETCHING";
export const HTTP_TEMPLATES_SUCCESS = "HTTP_TEMPLATES_SUCCESS";
export const HTTP_TEMPLATES_FAILED = "HTTP_TEMPLATES_FAILED";

export const HTTP_REPORT_RESPONSE_FETCHING = "HTTP_REPORT_RESPONSE_FETCHING";
export const HTTP_REPORT_RESPONSE_SUCCESS = "HTTP_REPORT_RESPONSE_SUCCESS";
export const HTTP_REPORT_RESPONSE_FAILED = "HTTP_REPORT_RESPONSE_FAILED";